import { Routes } from '@angular/router';
import { FleetOwnersDetailsSettingsService } from '@app/admin/fleet-owners/settings/services/fleet-owners-details-settings.service';

export const fleetOwnersRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('@app/admin/fleet-owners/overview/fleet-owners-overview.component').then(component => component.FleetOwnersOverviewComponent),
  },
  {
    path: ':id/overview',
    loadComponent: () => import('@app/admin/fleet-owners/details/fleet-owners-details-overview.component').then(component => component.FleetOwnersDetailsOverviewComponent),
  },
  {
    path: ':id/settings',
    loadComponent: () => import('@app/admin/fleet-owners/settings/settings.component').then(component => component.SettingsComponent),
    providers: [FleetOwnersDetailsSettingsService],
  },
];
